var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.411 17.411 3.589 3.589m-7.125-2.175c-.6181.1169-1.2459.1755-1.875.175-4.47797 0-8.26797-2.943-9.54297-7 .34327-1.0919.87199-2.11654 1.563-3.029zm-3.99697-8.946c.56267-.56266 1.32577-.87875 2.12147-.87875s1.5589.31609 2.1215.87875c.5627.5627.8788 1.3258.8788 2.1215s-.3161 1.5588-.8788 2.1215zm0-.001 4.24197 4.242zm.002.002-3.29-3.29zm4.24197 4.242 3.29 3.29zm-11.12197-11.122 3.59 3.59zm3.59 3.59c1.61236-1.04043 3.49107-1.5926 5.40997-1.59 4.478 0 8.268 2.943 9.543 7-.7039 2.2305-2.1656 4.1446-4.132 5.411z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.bcbe23aaf7410b67752d8c6d28fed249.svg";
export { ForwardRef as ReactComponent };